var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","color":_vm.type === 'maindomain' || _vm.type === 'purple'
      ? '#6A32E033'
      : _vm.type === 'subdomain' || _vm.type === 'premium'
      ? '#005EEA33'
      : _vm.type === 'addon'
      ? '#07C07E33'
      : _vm.type === 'free' || _vm.type === 'expires'
      ? '#FF7A2F26'
      : _vm.type === 'disabled'
      ? '#F2F2F7'
      : '#f2f2f7'}},[_c('span',{staticClass:"p-3 font-weight-bold",style:(_vm.type === 'maindomain' || _vm.type === 'purple'
        ? 'color: #6A32E0'
        : _vm.type === 'subdomain' || _vm.type === 'premium'
        ? 'color: #005EEA'
        : _vm.type === 'addon'
        ? 'color: #07C07E'
        : _vm.type === 'free' || _vm.type === 'expires'
        ? 'color: #FF7A2F'
        : _vm.type === 'disabled'
        ? 'color: #797997'
        : 'color: #797997')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }